import {
  Box,
  CheckFilledIcon,
  GKButton,
  Grid2,
  HomeIcon,
  NumberIcon,
  PhoneIcon,
  PlusIcon,
  Show,
  StatusField,
  Typography,
} from "components";
import { AdvisorOnboardFormInterface } from "interfaces/OnboardingInterface";
import { useFormContext } from "react-hook-form";
import { useAppSelector } from "store/store";
import { numberToCurrency } from "utils";
import { handleReturnAmount } from "utils/helpers";

const AdvisorOnboardingCompleted = ({ setOpen }: { setOpen: any }) => {
  const form = useFormContext<AdvisorOnboardFormInterface>();

  const onBoardflowData = useAppSelector(
    (state) => state?.app?.onBoardflowData,
  );

  const onBoardingDetails = [
    {
      name: "Basket Name",
      value: form.getValues("basketObject.name") || "-",
      show: onBoardflowData.customizeSetting.basketFeePlan,
      statusComponent: false,
    },
    {
      name: "KYC",
      value: form.getValues("kyc.kycStatus") || "-",
      show: onBoardflowData.customizeSetting.kyc,
      statusComponent: true,
    },
    {
      name: "Risk Profiling",
      value: form.getValues("riskProfile.riskStatus") || "-",
      show: onBoardflowData.customizeSetting.riskprofiling,
      statusComponent: true,
    },
    {
      name: "Fee Plan",
      value: form.getValues("selectedFeePlan.name") || "-",
      show: onBoardflowData.customizeSetting.basketFeePlan,
      statusComponent: false,
    },
    {
      name: "Agreement",
      value: form.getValues("agreement.agreementStatus.status") || "Pending",
      show: onBoardflowData.customizeSetting.agreement,
      statusComponent: true,
    },
    {
      name: "Payment Amount",
      value:
        numberToCurrency(
          handleReturnAmount({
            skipAdvanceFee: form.getValues("skipAdvanceFee"),
            feePlanDetails: form.getValues("advanceFeePlan.feePlan"),
            advanceFeePlan: form.getValues("advanceFeePlan"),
            planDataObject: form.getValues("planDataObject"),
            isExitGST: onBoardflowData?.revenueWithGst,
          }) || 0,
        ) || "-",
      show: onBoardflowData.customizeSetting.payment,
      statusComponent: false,
    },
  ];

  return (
    <Grid2
      spacing={2}
      container
      sx={{
        width: {
          xs: "80%",
          md: "70%",
        },
      }}
      m={"auto"}
      py={5}
    >
      <Grid2 size={12} textAlign={"center"}>
        <img src="/Investor/risk-success.svg" alt="" />
        <Typography fontWeight={600} fontSize={24}>
          You are successfully onboarded!
        </Typography>
      </Grid2>

      <Grid2
        container
        size={12}
        sx={{
          p: 2,
          background: "#F8FAFC",
          borderRadius: 2,
        }}
      >
        <Grid2
          size={{ xs: 12, md: 6 }}
          spacing={2}
          container
          justifyContent={"center"}
          flexDirection={"column"}
        >
          <Typography fontWeight={600} fontSize={18}>
            {form.getValues("personalDetails.name") || "-"}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <Box
              sx={{
                borderRadius: 100,
                background: "#E3E8EF",
                height: 40,
                width: 40,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <PhoneIcon />
            </Box>
            <Box>
              <Typography fontWeight={500} color={"#697586"} fontSize={12}>
                Phone No.
              </Typography>
              <Typography fontWeight={500} color={"#697586"} fontSize={14}>
                {form.getValues("phone") || "-"}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <Box
              sx={{
                borderRadius: 100,
                background: "#E3E8EF",
                height: 40,
                width: 40,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <NumberIcon />
            </Box>
            <Box>
              <Typography fontWeight={500} color={"#697586"} fontSize={12}>
                Client Code
              </Typography>
              <Typography fontWeight={500} color={"#697586"} fontSize={14}>
                {form.getValues("clientCode") || "-"}
              </Typography>
            </Box>
          </Box>
        </Grid2>
        <Grid2
          size={{ xs: 12, md: 6 }}
          container
          p={2}
          bgcolor={"#FFFF"}
          spacing={2}
          borderRadius={1}
        >
          {onBoardingDetails.map((dataItem) => {
            return (
              <Show.When isTrue={dataItem.show}>
                <Grid2 container size={12}>
                  <Grid2
                    size={12}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <CheckFilledIcon
                      color={"var(--success-700)"}
                      height={16}
                      width={16}
                    />
                    <Typography
                      fontWeight={500}
                      color={"#697586"}
                      fontSize={12}
                    >
                      {dataItem.name}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} ml={"28px"}>
                    {dataItem.statusComponent ? (
                      <StatusField statusString={dataItem.value} />
                    ) : (
                      <Typography fontWeight={500} color={"#333"} fontSize={14}>
                        {dataItem.value}
                      </Typography>
                    )}
                  </Grid2>
                </Grid2>
              </Show.When>
            );
          })}
        </Grid2>
      </Grid2>

      <Grid2
        size={12}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={1}
      >
        <GKButton
          variant="outlined"
          startIcon={<HomeIcon />}
          onClick={() => {
            setOpen(false);
          }}
        >
          Back to Home
        </GKButton>
        <GKButton
          variant="contained"
          startIcon={<PlusIcon />}
          onClick={() => {
            form.reset({
              activeStep: 0,
              type: "",
              personalDetails: {
                email: "",
                name: "",
                gender: "",
                maritalStatus: "",
                fatherName: "",
                motherName: "",
                dateOfBirth: "",
                address: "",
                city: "",
                state: "",
                country: "",
                pincode: "",
                income: "",
                occupation: "",
                pan: "",
                aadhar: "",
                emergencyContact: "",
                emergencyContactNum: "",
              },
              branch: "",
              family: [],
              signatureType: "",
              isExistingClient: false,
              phone: "",
              countryCode: "+91",
              bankAccounts: [],
              dematAccounts: [],
              nominees: [],
              kyc: null,
              document: [],
              id: "",
              sendOptions: "",
              manual: "",
              identification_type: "",
              riskProfile: null,
              agreement: "",
              basketObject: null,
              partner: null,
              portfolioObject: null,
              riskProfileObject: null,
              selectedFeePlan: null,
              planDataObject: {
                aumCash: "",
                showHoldingsModal: false,
                aumBasedPlan: "",
                subscriptionPlan: null,
                holdingsValue: null,
                subscriptionPlanAccountType: null,
                holdingsProofs: [],
                cashProofs: [],
                plansHoldings: [
                  {
                    gridCode: "",
                    quantity: 0,
                    cmp: "",
                    id: 0,
                  },
                ],
              },
            });
          }}
        >
          Add New Client
        </GKButton>
      </Grid2>
    </Grid2>
  );
};

export default AdvisorOnboardingCompleted;
